import { Lightbulb } from "lucide-react";
import { SectionCard } from "../Section";
import { MotivationPlant } from "./MotivationPlant";

export function MotivationBanner({ message }: { message: string }) {
  return (
    <SectionCard className="border-primary/15 from-primary/8 to-primary/5 flex items-center gap-3 bg-gradient-to-r p-4 sm:gap-4 sm:p-5">
      <span className="bg-primary/12 text-primary grid size-10 shrink-0 place-items-center rounded-2xl sm:size-11">
        <Lightbulb className="size-5" aria-hidden="true" />
      </span>
      <p className="min-w-0 flex-1 text-sm leading-relaxed">{message}</p>
      <MotivationPlant className="size-12 shrink-0 sm:size-14" />
    </SectionCard>
  );
}
